/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { MonthlySnapshotData } from '../models/MonthlySnapshotData';
import { VaultSnapshotCount } from '../models/VaultSnapshotCount';

/**
* Snapshot distribution data for a specific year
*/
export class YearlySnapshotDistribution {
  /**
  * The year (e.g., 2026)
  */
  'year': number;
  /**
  * Total number of snapshots for this year
  */
  'totalCount': number;
  /**
  * Total number of cluster snapshots for this year (only present for Aurora Global Database clusters)
  */
  'clusterCount'?: number;
  /**
  * Aggregated snapshot counts grouped by vault for the entire year
  */
  'snapshotsPerVault': Array<VaultSnapshotCount>;
  /**
  * Total number of non-Eon snapshots (cloud provider snapshots not managed by Eon) for this year
  */
  'nonEonSnapshotCount': number;
  /**
  * Monthly snapshot distribution data, sorted by month descending (most recent first)
  */
  'months': Array<MonthlySnapshotData>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "year",
      "baseName": "year",
      "type": "number",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "clusterCount",
      "baseName": "clusterCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "snapshotsPerVault",
      "baseName": "snapshotsPerVault",
      "type": "Array<VaultSnapshotCount>",
      "format": ""
    },
    {
      "name": "nonEonSnapshotCount",
      "baseName": "nonEonSnapshotCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "months",
      "baseName": "months",
      "type": "Array<MonthlySnapshotData>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return YearlySnapshotDistribution.attributeTypeMap;
  }

  public constructor() {
  }
}

